import Rx from 'rx';
import {notAuthorizedMessage} from '../services/not-authorized.js';

export default function MemberWeeklySummaryCtrl($scope, $wamp, progressBar) {

  $scope.meta = {lastUpdated: new Date()};

  progressBar.add('org.eggs.get_weekly_trading_summary');

  var transactionOrder = {
    "SALES": 1,
    "BIDS": 2,
    "OFFERS": 3
  };

  var weeklySummary$ = Rx.Observable.fromPromise($wamp.call("org.eggs.get_weekly_trading_summary"))
      .do(function () {
        progressBar.remove('org.eggs.get_weekly_trading_summary');
      })
      // A login the backend won't show the summary to (no trading access): its message in place of
      // the table.
      .catch(function (err) {
        progressBar.remove('org.eggs.get_weekly_trading_summary');
        var message = notAuthorizedMessage(err);
        if (!message) {
          return Rx.Observable.throw(err);
        }
        $scope.$applyAsync(function () {
          $scope.refused = message;
        });
        return Rx.Observable.empty();
      });

  var dateRange$ = weeklySummary$.safeApply($scope, function (res) {
    $scope.start = res[1];
    $scope.end = res[2];
  });

  var trade$ = weeklySummary$
      .map(function (res) {
        return res[0];
      })
      .flatMap(function (res) {
        return Rx.Observable.fromArray(res)
        //Add order properties
            .flatMap(function (x) {
              return Rx.Observable.fromArray(x[1])
                  .map(function (trade) {
                    trade.order = transactionOrder[trade.transaction_type];
                    trade.eggTypeTokens = (trade.egg_type || '').split(/\s+/).filter(Boolean);
                    return trade;
                  })
                  .toArray()
                  .combineLatest(
                      Rx.Observable.just(x[2]),
                      function (items, order) {
                        return {
                          items: items,
                          order: order
                        }
                      }
                  );
            })
            .toArray();
      })
      .safeApply($scope, function (grouped) {
        $scope.trades = grouped;
      });

  trade$.merge(dateRange$).subscribe();

  //Column sorting (sorts egg-type groups by aggregated values; transaction rows stay SALES/BIDS/OFFERS)
  $scope.sortField = 'order';
  $scope.sortReverse = false;
  $scope.sortKey = null;

  var num = function (v) { return parseFloat(v) || 0; };

  var sumBy = function (items, prop) {
    return items.reduce(function (s, i) { return s + num(i[prop]); }, 0);
  };

  var avgNonZero = function (items, prop) {
    var vals = items.map(function (i) { return num(i[prop]); }).filter(function (v) { return v > 0; });
    return vals.length ? vals.reduce(function (s, v) { return s + v; }, 0) / vals.length : 0;
  };

  var sortHandlers = {
    'egg_type': function (g) { return g.items[0] ? g.items[0].egg_type : ''; },
    'quantity': function (g) { return sumBy(g.items, 'quantity'); },
    'cases':    function (g) { return sumBy(g.items, 'cases'); },
    'regions':  function (g) {
      var all = [];
      g.items.forEach(function (i) {
        if (i.regions) { all = all.concat(i.regions); }
      });
      return all.slice().sort().join('');
    },
    'min':      function (g) {
      var vals = g.items.map(function (i) { return num(i.min); }).filter(function (v) { return v > 0; });
      return vals.length ? Math.min.apply(null, vals) : 0;
    },
    'max':      function (g) {
      var vals = g.items.map(function (i) { return num(i.max); }).filter(function (v) { return v > 0; });
      return vals.length ? Math.max.apply(null, vals) : 0;
    },
    'average':  function (g) { return avgNonZero(g.items, 'average'); },
    'freight':  function (g) { return avgNonZero(g.items, 'freight'); }
  };

  $scope.sortBy = function (field) {
    if ($scope.sortKey === field) {
      if ($scope.sortReverse) {
        $scope.sortField = 'order';
        $scope.sortReverse = false;
        $scope.sortKey = null;
      } else {
        $scope.sortReverse = true;
      }
    } else {
      $scope.sortField = sortHandlers[field] || 'order';
      $scope.sortReverse = false;
      $scope.sortKey = field;
    }
  };
}